import React from "react";
import styled from "@emotion/styled";
import { SyncStatus } from "~/gql/types";
import { Subtitle2 } from "@material/react-typography";
import { keyframes } from "@emotion/react";
import MaterialIcon from "@material/react-material-icon";

const Display = styled("div")`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-left: 8px;
  gap: 4px;
`;

const Label = styled(Subtitle2)`
  margin: 0;
`;

type SyncStatusDisplayProps = {
  status: SyncStatus;
};

export const SyncStatusDisplay: React.FC<SyncStatusDisplayProps> = ({
  status,
}) => {
  const synced = status === SyncStatus.Synced;
  const error =
    status === SyncStatus.Error || status === SyncStatus.RenameFailed;
  const pendingMove = status === SyncStatus.PendingMove;

  const pulseAnimation = keyframes`
    0% {
      box-shadow: 0 0 0 0 rgba(239, 198, 0, 1);
    }
    95% {
      box-shadow: 0 0 0 4px rgba(239, 198, 0, 0);
    }
    100% {
      box-shadow: 0 0 0 0 rgba(239, 198, 0, 0);
    }
  `;

  const Indicator = styled("div")`
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: ${synced
      ? "#00ac18"
      : error
      ? "#f01716"
      : "rgb(239, 198, 0)"};
  `;

  const PulsingIndicator = styled(Indicator)`
    animation: ${pulseAnimation} 2s infinite;
  `;

  const PendingMoveIcon = styled(MaterialIcon)`
    font-size: 20px;
    width: 20px;
    color: rgb(239, 198, 0);
  `;

  return (
    <Display>
      <Label>
        {synced
          ? "Synced"
          : error
          ? "Sync error"
          : pendingMove
          ? "Pending move"
          : "Sync pending"}
      </Label>
      {synced || error ? (
        <Indicator />
      ) : pendingMove ? (
        <PendingMoveIcon icon="error_outline_outlined" />
      ) : (
        <PulsingIndicator />
      )}
    </Display>
  );
};
